webpackJsonp([262714004760667],{

/***/ 360:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Church Services | Killasser Parish","author":"Kingluddite"}},"contentfulConfession":{"title":"Confession","slug":"confession","metaDescription":"Killasser Parish Church Confession Times and Information","headerBackgroundImage":{"file":{"url":"//images.ctfassets.net/6rnd0h65xc7e/59bfPSPUzCiQiAes8EuCMi/29308115017e19d1584563d7a6835bd1/confessional.jpg"}},"sectionFourHeading":"The Sacrament of Reconciliation","sectionFourContent":{"childMarkdownRemark":{"html":"<table>\n<thead>\n<tr>\n<th>Time</th>\n<th>Day</th>\n<th>Location</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>7.30pm - 8pm</td>\n<td>Saturday</td>\n<td>Killasser</td>\n</tr>\n</tbody>\n</table>"}}}},"pathContext":{"slug":"/confession/","langKey":"en-US"}}

/***/ })

});


// WEBPACK FOOTER //
// path---confession-6baf8e3ffc9a050cd749.js